<template>
  <div class="cores">
    <template>
      <v-card>
        <v-card-title>
          CLD Loan Importer Config
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card>
          <v-container fluid>
            <v-row align="center"></v-row>
            <v-row>
              <v-data-table
                :headers="headers"
                :items="cldConfigs"
                :items-per-page="10"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.fiId }}</td>
                  <td>{{ props.item.policyType }}</td>
                  <td>{{ props.item.policyNumber }}</td>
                  <td>{{ props.item.description }}</td>
                  <td>{{ props.item.isDebtProtection }}</td>
                  <td>
                    <v-btn
                      v-if="userWritePrivileges"
                      color="red"
                      dark
                      @click="deleteConfig(props.item)"
                    >
                      <font-awesome-icon icon="trash-alt" class="pr-1"/>
                      Delete
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

              <v-dialog
                v-model="dialog"
                persistent
                max-width="500px"
                v-if="userWritePrivileges"
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on"
                  >Add Config
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Add Config</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="newFiid"
                            type="number"
                            label="FI ID"
                            :rules="['Required']"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="policyType"
                            type="text"
                            label="Policy Type"
                            :rules="['Required']"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="policyNumber"
                            type="text"
                            label="Policy Number"
                            :rules="['Required']"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="description"
                            type="text"
                            label="Description"
                            :disabled="!isDebtProtection"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        Debt Protection
                        <v-col cols="12" sm="6" md="4">
                          <input
                            label="Debt Protection"
                            type="checkbox"
                            v-model="isDebtProtection"
                            name="IsDebtProtection"
                            @click="clearDescription()"
                          >
                          </input>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close()"
                    >Cancel
                    </v-btn
                    >
                    <v-btn
                      v-if="userWritePrivileges"
                      color="blue darken-1"
                      text
                      @click="addConfig()"
                    >Add
                    </v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-container>
        </v-card>
      </v-card>
    </template>
  </div>
</template>
<script>
import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import { Component, Prop } from 'vue-property-decorator';
import CldRequestService from '@/CldRequestService.vue';
import RequestService from '@/RequestService.vue';

@Component
export default class CldLoanImporterConfig extends Vue {
  /*eslint-disable */
  data() {
    return {
      dialog: false,
      uuId: '',
      newFiid: '',
      policyType: '',
      policyNumber: '',
      description: '',
      userWritePrivileges: false,
      cldConfigs: [],
      isDebtProtection: false,
    };
  }

  /* eslint-enable */
  headers = [
    {
      text: 'FI ID',
      value: 'item.fiId',
      sortable: true,
      align: 'left',
    },
    {
      text: 'Policy Type',
      value: 'item.policyType',
      sortable: true,
      align: 'left',
    },
    {
      text: 'Policy Number',
      value: 'item.policyNumber',
      sortable: true,
      align: 'left',
    },
    {
      text: 'Description',
      value: 'item.description',
      sortable: true,
      align: 'left',
    },
    {
      text: 'Debt Protection',
      value: 'item.isDebtProtection',
      sortable: true,
      align: 'left',
    },
    {
      text: 'Actions',
      value: 'action',
      sortable: false,
    },
  ];

  emptyPayload = {
    uuId: '',
    fiId: '',
    policyType: '',
    policyNumber: '',
    description: '',
    isDebtProtection: false,
  };

  editedPayload = this.emptyPayload;

  async clearDescription() {
    if (this.isDebtProtection === true) {
      setTimeout(() => {
        this.description = '';
      }, 300);
    }
  }

  async addConfig() {
    const newConfig = {
      uuId: this.uuId,
      fiId: this.newFiid,
      policyType: this.policyType,
      policyNumber: this.policyNumber,
      description: this.description,
      isDebtProtection: this.isDebtProtection,
    };
    const existingConfig = this.cldConfigs.find(
      config => config.fiId === newConfig.fiId
        && config.policyType === newConfig.policyType
        && config.description === newConfig.description,
    );

    const duplicateConfig = this.cldConfigs.find(
      config => config.fiId === newConfig.fiId
        && config.policyType === newConfig.policyType
        && ((config.description === '' && newConfig.description === '')
          || (config.isDebtProtection === newConfig.isDebtProtection)),
    );

    const existingPolicyNumber = this.cldConfigs.find(
      config => config.fiId === newConfig.fiId
        && config.policyType === newConfig.policyType
        && config.policyNumber === newConfig.policyNumber,
    );

    if (this.newFiid === '') {
      window.alert('FI ID cannot be blank.');
    } else if (existingConfig) {
      window.alert(`Config for ${this.newFiid} with ${this.policyType} and ${this.description} already exists`);
    } else if (existingPolicyNumber) {
      window.alert(`Config for ${this.newFiid} with ${this.policyType} and ${this.policyNumber}
      already exists`);
    } else if (duplicateConfig) {
      window.alert(`Duplicate config was found for ${this.newFiid} with ${this.policyType}`);
    } else {
      if (
        window.confirm(`Add config for ${this.newFiid} with policy type ${this.policyType}?`)
      ) {
        if (!this.isDebtProtection) this.description = '';
        this.dialog = true;
        this.uuId = uuidv4();
        this.editedPayload.uuId = this.uuId;
        this.editedPayload.fiId = this.newFiid;
        this.editedPayload.policyType = this.policyType;
        this.editedPayload.policyNumber = this.policyNumber;
        this.editedPayload.description = this.description;
        this.editedPayload.isDebtProtection = this.isDebtProtection;
        await CldRequestService.updateCldConfig(this.editedPayload);
        this.cldConfigs.push(newConfig);
        this.editedPayload = this.emptyPayload;
      }
      this.close();
    }
  }

  async deleteConfig(item) {
    if (window.confirm(`Delete config for ${item.fiId} with policy type ${item.policyType}
    and description ${item.description}?`)) {
      await CldRequestService.deleteCldConfig(item);
      const fiidIdxToDelete = this.cldConfigs.indexOf(item);
      this.cldConfigs.splice(fiidIdxToDelete, 1);
    }
  }

  close() {
    this.dialog = false;
    setTimeout(() => {
      this.newFiid = '';
      this.policyType = '';
      this.policyNumber = '';
      this.description = '';
      this.isDebtProtection = false;
    }, 300);
  }

  async mounted() {
    this.cldConfigs = await CldRequestService.getAllCldConfigs();
    this.userWritePrivileges = await RequestService.checkCredentials();
  }
}
</script>
